import React from "react";
import Home from "../pages/Home";
import { useVerifyUser } from "../../hooks/useVerifyUser";
import AccessDenied from "../layout/AccessDenied";
import Spinner from "../Spinner/Spinner";
import DepartmentPage from "../pages/DepartmentPage";

const VerifyUsers = () => {
  const { isLoading, isAuth } = useVerifyUser();
  return (
    <div>
      {isLoading && (
        <div
          style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "16px",
            background: "#f9f9f9",
          }}
        >
          <Spinner />
          <p style={{ fontSize: "15px", color: "#555", fontWeight: 500, margin: 0 }}>
            Verifying your access, please wait...
          </p>
        </div>
      )}

      {!isLoading && isAuth && (
        <>
          <DepartmentPage />
        </>
      )}

      {!isLoading && !isAuth && <AccessDenied />}
    </div>
  );
};

export default VerifyUsers;
